export default __webpack_public_path__ + "static/wand-education_small-image_3-d1e54737acb8a146a44a06f296847701.webp";